module.exports = __webpack_public_path__ + "img/fullscreen.ddcd813e.svg";